import { z } from 'zod';
import {
  LoginResponse,
  loginResponseZod,
  UserInfo,
  userInfoZod,
} from '../model';
import { get, post, put } from './BaseApi';
import { getLocalToken } from './TokenStorage';

export async function login(
  account: string,
  password: string,
  sync: boolean
): Promise<LoginResponse> {
  const localToken = getLocalToken();
  return post('/api/user/login', loginResponseZod, {
    account,
    password,
    sync,
    clientId: localToken,
  });
}

export async function refreshToken(schoolId?: string): Promise<LoginResponse> {
  const localToken = getLocalToken();
  return post('/api/token/refresh', loginResponseZod, {
    schoolId,
    clientId: localToken,
  });
}

export async function getUserInfo(): Promise<UserInfo> {
  return get('/api/user', userInfoZod);
}

export async function logout(): Promise<void> {
  return post('/api/user/logout');
}

export async function sendOTPCode(
  schoolId: string
): Promise<LoginResponse | undefined | null> {
  const localToken = getLocalToken();
  const res = await post('/api/user/otp/send', loginResponseZod.nullish(), {
    schoolId,
    clientId: localToken,
  });
  return res;
}

export async function verifyOTPCode(
  schoolId: string,
  otp: string
): Promise<LoginResponse> {
  const localToken = getLocalToken();
  return post('/api/user/otp/verify', loginResponseZod, {
    schoolId,
    otp,
    clientId: localToken,
  });
}
